import * as React from 'react';

import ProfileCard from 'components/cards/profile-card/ProfileCard';
import InputToggles from 'components/inputs/input-toggles/InputToggles';
import StatusLabel from 'components/status-label/StatusLabel';

import ProfileFashionStyles from '../../components/profile-fashion-styles/ProfileFashionStyles';
import ProfileFashionCategories from '../../components/profile-fashion-categories/ProfileFashionCategories';
import ProfileFashionSizes from '../../components/profile-fashion-sizes/ProfileFashionSizes';

import { __t, applyTranslations } from 'utils/language';

import './profile-fashion-identity.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-fashion-identity.i18n.json'));

import type {
  Data,
  InfluencerFashionIdentityType,
  InfluencerInputToggleItem,
  InfluencerProfileForm
} from 'types';

interface Props {
  profile: InfluencerProfileForm,
  hideNew: boolean,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_fashion_identity';

const ProfileFashionIdentity: React.FC<Props> = ({
  profile,
  hideNew,
  onChange
}) => {
  const handleTogglesUpdate = (
    values: Array<string>,
    data: Data
  ): void => {
    onChange({
      [data.type]: values
    });
  };

  const renderInputToggles = (
    type: InfluencerFashionIdentityType,
    items: Array<InfluencerInputToggleItem>,
    limit: number = 3
  ): React.ReactNode => (
    <InputToggles
      key={`profile-fashion-identity__input-toggles--${type}`}
      items={items}
      value={profile[type] || []}
      limit={limit}
      onChange={handleTogglesUpdate}
      data={{ type }}
    />
  );

  return (
    <div
      id="profile-fashion-identity"
      className="profile-fashion-identity"
    >
      <div className="profile-fashion-identity__title">
        <div className="profile-fashion-identity__title-text">
          {__t(`${MSG_KEY}.title`)}
        </div>
        {
          !hideNew && (
            <div className="profile-fashion-identity__title-marker">
              <StatusLabel
                label={(__t(`${COMMON_MSG_KEY}.basics.new`) || '').toUpperCase()}
                layout="marker"
              />
            </div>
          )
        }
      </div>
      <div className="profile-fashion-identity__description">
        {__t(`${MSG_KEY}.description`)}
      </div>
      <ProfileCard
        classNameContents="profile-fashion-identity__contents"
      >
        <ProfileFashionStyles
          renderInputToggles={renderInputToggles}
        />
        <ProfileFashionCategories
          renderInputToggles={renderInputToggles}
        />
        <ProfileFashionSizes
          renderInputToggles={renderInputToggles}
        />
      </ProfileCard>
    </div>
  );
};

export default ProfileFashionIdentity;
